import {
  CHECK_PHONE_EXISTS,
  CHECK_PHONE_EXISTS_FAILED,
  CHECK_PHONE_EXISTS_SUCCESS,
  CREATE_BIZ_ACCOUNT,
  CREATE_BIZ_ACCOUNT_FAILED,
  CREATE_BIZ_ACCOUNT_SUCCESS,
  FORGOT_PASSWORD_PIN,
  FORGOT_PASSWORD_PIN_FAILED,
  FORGOT_PASSWORD_PIN_SUCCESS,
  GET_LOCATION,
  GET_LOCATION_SUCCESS,
  GET_PROFILE_BIZ_CUSTOMER,
  GET_PROFILE_BIZ_CUSTOMER_FAILED,
  GET_PROFILE_BIZ_CUSTOMER_SUCCESS,
  REQUEST_LOGIN,
  REQUEST_LOGIN_FAILED,
  REQUEST_LOGIN_SUCCESS,
  REQUEST_NEW_OTP_CODE,
  REQUEST_NEW_OTP_CODE_FAILED,
  RESET_STATE,
  STORE_BIZ_ACCOUNT_CURRENT_PASSWORD,
  STORE_BIZ_ACCOUNT_CUSTOMER_CODE,
  UPDATE_BIZ_ACCOUNT_PASSWORD,
  UPDATE_PASSWORD_PIN,
  UPDATE_PASSWORD_PIN_SUCCESS,
  VERIFY_CODE,
  VERIFY_CODE_FAILED,
  VERIFY_CODE_SUCCESS
} from './actionTypes';
import {
  AuthLogin,
  AuthLoginFailed,
  AuthRequestVerifyCode,
  AuthState,
  AuthUpdatePasswordBizAccount,
  AuthUpdatePasswordBizAccountPayload,
  AuthUpdatePasswordPIN,
  AuthUpdatePasswordPINPayload,
  AuthUpdatePasswordPINSuccess,
  AuthUpdatePasswordPINSuccessPayload,
  AuthVerifyCode,
  AuthVerifyCodeFailed,
  AuthVerifyCodeFailedPayload,
  AuthVerifyCodeSuccess,
  AuthVerifyCodeSuccessPayload,
  businessAccountPayload,
  CheckPhoneExist,
  CheckPhoneExistFailed,
  CheckPhoneExistFailedPayload,
  CheckPhoneExistSuccess,
  CheckPhoneExistSuccessPayload,
  ForgotPasswordPIN,
  ForgotPasswordPINFailed,
  ForgotPasswordPinSuccess,
  locationPayload,
  RequestLogin,
  RequestNewOTP,
  RequestNewOTPFailed, UserProfile
} from './types';

// check phone exist actions
export const checkPhoneExistAction = (phone: string): CheckPhoneExist => ({
  type: CHECK_PHONE_EXISTS,
  phone,
});

export const checkPhoneExistSuccessAction = (
  payload: CheckPhoneExistSuccessPayload,
): CheckPhoneExistSuccess => ({
  type: CHECK_PHONE_EXISTS_SUCCESS,
  payload,
});

export const checkPhoneExistFailedAction = (
  payload: CheckPhoneExistFailedPayload,
): CheckPhoneExistFailed => ({
  type: CHECK_PHONE_EXISTS_FAILED,
  payload,
});

//request new OTP action
export const requestNewOTPAction = (phone: string): RequestNewOTP => ({
  type: REQUEST_NEW_OTP_CODE,
  phone,
});
export const requestNewOTPActionFailed = (
  message: string,
): RequestNewOTPFailed => ({
  type: REQUEST_NEW_OTP_CODE_FAILED,
  message,
});

// verify phone code action
export const requestVerifyCodeAction = (
  payload: AuthVerifyCode,
): AuthRequestVerifyCode => ({
  type: VERIFY_CODE,
  phone: payload.phone || '',
  code: payload.code || '',
});

export const verifyPhoneCodeSuccessAction = (
  payload: AuthVerifyCodeSuccessPayload,
): AuthVerifyCodeSuccess => ({
  type: VERIFY_CODE_SUCCESS,
  payload,
});

export const verifyPhoneCodeFailedAction = (
  payload: AuthVerifyCodeFailedPayload,
): AuthVerifyCodeFailed => ({
  type: VERIFY_CODE_FAILED,
  payload,
});

// UPDATE_PASSWORD_PIN action
export function updatePasswordPINAction(
  payload: AuthUpdatePasswordPINPayload,
): AuthUpdatePasswordPIN {
  return {
    type: UPDATE_PASSWORD_PIN,
    phone: payload.phone,
    user_name: payload.user_name,
    pin: payload.pin,
    verified_token: payload.verified_token,
  };
}

export function updatePasswordPINActionSuccess(
  payload: AuthUpdatePasswordPINSuccessPayload,
): AuthUpdatePasswordPINSuccess {
  return {
    ...payload,
    type: UPDATE_PASSWORD_PIN_SUCCESS,
  };
}

// update password biz account
export function updatePasswordBizAccountAction(
  payload: AuthUpdatePasswordBizAccountPayload,
): AuthUpdatePasswordBizAccount {
  return {
    type: UPDATE_BIZ_ACCOUNT_PASSWORD,
    old_password: payload.old_password,
    new_password: payload.new_password,
  };
}

export const forgotPasswordPINAction = (phone: string): ForgotPasswordPIN => ({
  type: FORGOT_PASSWORD_PIN,
  phone,
});

export function forgotPasswordPINSuccessAction(
  payload: CheckPhoneExistSuccessPayload,
): ForgotPasswordPinSuccess {
  return {
    type: FORGOT_PASSWORD_PIN_SUCCESS,
    payload,
  };
}

export function forgotPasswordPINFailedAction(
  payload: CheckPhoneExistFailedPayload,
): ForgotPasswordPINFailed {
  return {
    type: FORGOT_PASSWORD_PIN_FAILED,
    payload,
  };
}

// login
export const requestLoginAction = (payload: AuthLogin): RequestLogin => ({
  type: REQUEST_LOGIN,
  username: payload.username,
  password: payload.password,
});

export const requestLoginSuccessAction = (payload: AuthState) => ({
  type: REQUEST_LOGIN_SUCCESS,
  isLoggedIn: payload.isLoggedIn || false,
  accessToken: payload.accessToken || '',
  expiresIn: payload.expiresIn || 0,
  refreshToken: payload.refreshToken || '',
  tokenType: payload.tokenType || '',
  status: payload.status || '',
});

export const requestLoginFailedAction = ({
  message,
  errorCode,
}: {
  message: string;
  errorCode: string;
}): AuthLoginFailed => ({
  type: REQUEST_LOGIN_FAILED,
  message,
  errorCode,
});

export const resetStateAction = (payload = {} as AuthState): any => ({
  type: RESET_STATE,
  payload
});

export const requestGetProfile = (): any => ({
  type: GET_PROFILE_BIZ_CUSTOMER,
});

export const requestGetProfileSuccess = (payload: UserProfile): any => ({
  type: GET_PROFILE_BIZ_CUSTOMER_SUCCESS,
  payload,
});

export const requestGetProfileFailed = ({
  message,
  errorCode,
}: {
  message: string;
  errorCode: string;
}) => ({
  type: GET_PROFILE_BIZ_CUSTOMER_FAILED,
  message,
  errorCode,
});

export const storeBizAccountCurrentPassword = ({
  password,
}: {
  password: string;
}) => ({
  type: STORE_BIZ_ACCOUNT_CURRENT_PASSWORD,
  password,
});

export const storeBizAccountCustomerCode = ({
  customerCode,
}: {
  customerCode: string;
}) => ({
  type: STORE_BIZ_ACCOUNT_CUSTOMER_CODE,
  customerCode,
});

export const requestCreateBizAccount = (data: businessAccountPayload) => ({
  type: CREATE_BIZ_ACCOUNT,
  data,
});

export const requestCreateBizAccountSuccess = (
  payload: businessAccountPayload,
) => ({
  type: CREATE_BIZ_ACCOUNT_SUCCESS,
  payload,
});

export const requestCreateBizAccountFailed = (bizErrors: any) => ({
  type: CREATE_BIZ_ACCOUNT_FAILED,
  bizErrors,
});

export const requestLocation = ({
  locationType,
  id,
}: {
  locationType: 'country' | 'province' | 'district' | 'ward';
  id: string;
}) => ({
  type: GET_LOCATION,
  locationType,
  id,
});

export const requestLocationSuccess = ({
  locationType,
  data,
}: {
  locationType: 'country' | 'province' | 'district' | 'ward';
  data: locationPayload;
}) => ({
  type: GET_LOCATION_SUCCESS,
  locationType,
  data,
});
